import Client from "../AxiosClient";
const resource = "/private/departments/";

export default {
  async get_department_byuser(params) {
    // console.log("getTarget");
    try {
      console.log(
        `${resource}list_department_byuser?department_type=${params.department_type}`
      );
      const response = await Client.get(
        `${resource}list_department_byuser?department_type=${params.department_type}`
      );

      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  create(payload) {},

  update(payload) {},

  delete(id) {},
};
